


















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ChartOptionsMenu from './ChartOptionsMenu.vue'

@Component({
    components: {
        ChartOptionsMenu
    }
})
export default class PieChart extends Vue {
    @Prop({ required: true }) loading!: boolean
    @Prop({ required: true }) title!: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop({ required: true }) data!: any;

    noData = false
    localLoading = true
    series = []

    chartOptions = {
        labels: [],
        legend: {
            labels: {
                colors: '#fff'
            }
        }
    };

    @Watch('loading')
    ondialogPropChange () {
        this.localLoading = this.loading
    }

    changeChart (chart: string) {
        this.$emit('change-chart', { index: this.data.widgetId, chart })
    }

    getReportData () {
        this.localLoading = true
        this.$store.dispatch('viewReport', {
            reportId: this.data.reportId.reportId,
            reportFilters: []
        })
            .then((resp) => {
                if (resp?.status === 200) {
                    this.formatData(resp.data)
                }
                this.localLoading = false
            })
            .catch((error) => {
                this.localLoading = false
                console.log(error)
            })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formatData (data: any) {
        if (data.query.length > 0) {
            this.noData = false
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const cols = data.query.map((x: any) => {
                return x[Object.keys(x)[0]]
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const values = data.query.map((x: any) => {
                return parseInt(x[Object.keys(x)[1]])
            })
            this.series = values
            this.chartOptions.labels = cols
        } else {
            this.noData = true
        }
    }

    mounted () {
        this.getReportData()
        setInterval(this.getReportData, 300000)
    }
}
